var _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#FCCECE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 24H23.1667H44.5",
    stroke: "#E02B2B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8346 23.9998C42.8346 23.4476 42.3869 22.9998 41.8346 22.9998C41.2824 22.9998 40.8346 23.4476 40.8346 23.9998H42.8346ZM24.168 23.9998C24.168 23.4476 23.7203 22.9998 23.168 22.9998C22.6157 22.9998 22.168 23.4476 22.168 23.9998H24.168ZM26.168 23.9998C26.168 24.5521 26.6157 24.9998 27.168 24.9998C27.7203 24.9998 28.168 24.5521 28.168 23.9998H26.168ZM36.8346 23.9998C36.8346 24.5521 37.2824 24.9998 37.8346 24.9998C38.3869 24.9998 38.8346 24.5521 38.8346 23.9998H36.8346ZM40.8346 23.9998V42.6665H42.8346V23.9998H40.8346ZM40.8346 42.6665C40.8346 43.587 40.0884 44.3332 39.168 44.3332V46.3332C41.193 46.3332 42.8346 44.6915 42.8346 42.6665H40.8346ZM39.168 44.3332H25.8346V46.3332H39.168V44.3332ZM25.8346 44.3332C24.9142 44.3332 24.168 43.587 24.168 42.6665H22.168C22.168 44.6915 23.8096 46.3332 25.8346 46.3332V44.3332ZM24.168 42.6665V23.9998H22.168V42.6665H24.168ZM28.168 23.9998V21.3332H26.168V23.9998H28.168ZM28.168 21.3332C28.168 20.4127 28.9142 19.6665 29.8346 19.6665V17.6665C27.8096 17.6665 26.168 19.3081 26.168 21.3332H28.168ZM29.8346 19.6665H35.168V17.6665H29.8346V19.6665ZM35.168 19.6665C36.0884 19.6665 36.8346 20.4127 36.8346 21.3332H38.8346C38.8346 19.3081 37.193 17.6665 35.168 17.6665V19.6665ZM36.8346 21.3332V23.9998H38.8346V21.3332H36.8346Z",
    fill: "#E02B2B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.832 30.6665V38.6665",
    stroke: "#E02B2B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.168 30.6665V38.6665",
    stroke: "#E02B2B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelCircle);
export default __webpack_public_path__ + "static/media/delCircle.7482c3a9dba1f55edc4c0808556adbef.svg";
export { ForwardRef as ReactComponent };